import { render, staticRenderFns } from "./BasicInventoriesReport.vue?vue&type=template&id=5caa58ba&"
import script from "./BasicInventoriesReport.vue?vue&type=script&lang=js&"
export * from "./BasicInventoriesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports